import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class PathService {
  // #region Properties (2)

  private path: string = "";

  public redirect: boolean = false;

  // #endregion Properties (2)

  // #region Constructors (1)

  constructor() {
    console.log("Path service Constructor");
  }

  // #endregion Constructors (1)

  // #region Public Methods (3)

  public getPath(): string {
    console.log("GETTING PATH", this.path);

    let myPath = this.path;
    if (myPath === "") {
      if (window.location.hostname.startsWith("billing")) {
        myPath = "/billing/overview";
      } else if (window.location.hostname.startsWith("order")) {
        myPath = "/order/overview";
      } else if (window.location.hostname.startsWith("admin")) {
        myPath = "/admin";
      } else {
        myPath = "/home";
      }
    }

    return myPath;
  }

  public redirectNow(router: Router) {
    if (this.redirect) {
      const siteName = "/csrm-soc-e2e";
      console.log("Redirecting ......", this.path);
      const correctedUrl = this.path.replace(siteName, "");
      console.log(correctedUrl);
      router.navigateByUrl(correctedUrl);
      this.redirect = false;
    }
  }

  public setPath(path: string, redirect: boolean) {
    console.log("SETTING PATH", path);
    this.path = path;
    this.redirect = redirect;
  }

  // #endregion Public Methods (3)
}
